import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { AnalyticsService } from '@hdms/shared/util-core';

import { ContactTabType } from '../../../../config/header-config.const';
import {
  ContactFormAction,
  ContactFormCategory,
  ContactFormLabel
} from '../../contact-body/content/form/contact-form-component.abstract';

@Component({
  selector: 'shrd-pf-ft-contact-footer-content',
  templateUrl: './contact-footer-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactFooterContentComponent {
  @Input() actionLabel = 'common.label.button.submit';
  @Input() hasAction = true;
  @Input() actionUrl: string;
  @Input() isActionEnabled = true;
  @Input() inModal = false;
  @Input() contactTabType: ContactTabType;

  @Output() goBackAction = new EventEmitter<void>();

  protected readonly analyticsService = inject(AnalyticsService);

  onSubmitClick(): void {
    if (this.contactTabType === ContactTabType.FIND_STORE) {
      this.analyticsService.sendEvent(
        { category: ContactFormCategory.CONTACTUS, action: ContactFormAction.STORE, label: ContactFormLabel.SUBMIT },
        true
      );
    }
  }
}
